export const storageKeys = {
  CLIENT_KEY: 'client',
};

function setItem(key, value) {
  return new Promise(resolve => resolve(sessionStorage.setItem(key, value)));
}

function getItem(key) {
  return new Promise(resolve => {
    const value = sessionStorage.getItem(key);
    return resolve(value);
  });
}

export default {
  setItem,
  getItem,
};
